// theme-sources/js/core-ui/components/mobile-accordion.js

import { sectionLogger } from "./_logger";

const DEBUG = true;
const logger = sectionLogger("MobileAccordion", DEBUG);

class MobileAccordion extends HTMLElement {
  connectedCallback() {
    this.root = this.querySelector(".mobile-nav");
    if (!this.root) return;

    this.root.addEventListener("click", (e) => {
      const toggle = e.target.closest(".mobile-accordion-toggle");
      if (!toggle) return;

      this.toggle(toggle);
    });

    // ouvrir les items marqués is-open
    this.root
      .querySelectorAll(".mobile-accordion-toggle.is-open")
      .forEach((toggle) => {
        const panel = toggle.parentElement.querySelector(
          ".mobile-accordion-panel",
        );
        if (!panel) return;

        panel.classList.add("is-open");
        panel.style.maxHeight = panel.scrollHeight + "px";
      });
  }

  toggle(toggle) {
    const panel = toggle.parentElement.querySelector(".mobile-accordion-panel");
    const icon = toggle.querySelector(".tab-toggle");

    const willOpen = !toggle.classList.contains("is-open");

    if (willOpen) {
      this.root
        .querySelectorAll(".mobile-accordion-toggle.is-open")
        .forEach((otherToggle) => {
          const otherPanel = otherToggle.parentElement.querySelector(
            ".mobile-accordion-panel",
          );
          const otherIcon = otherToggle.querySelector(".tab-toggle");

          otherToggle.classList.remove("is-open");
          otherToggle.setAttribute("aria-expanded", false);

          if (otherIcon) otherIcon.classList.remove("is-open");

          if (otherPanel) {
            otherPanel.style.maxHeight = "0px";
            otherPanel.classList.remove("is-open");
          }
        });
    }

    toggle.classList.toggle("is-open", willOpen);
    toggle.setAttribute("aria-expanded", willOpen);

    if (icon) icon.classList.toggle("is-open", willOpen);

    if (!panel) return;

    if (willOpen) {
      panel.classList.add("is-open");
      panel.style.maxHeight = panel.scrollHeight + "px";
    } else {
      panel.style.maxHeight = "0px";
      panel.classList.remove("is-open");
    }
  }
}
if (!customElements.get("mobile-accordion")) {
  customElements.define("mobile-accordion", MobileAccordion);
}

document.addEventListener("click", (e) => {
  if (
    document.body.classList.contains("is-mobile-search-open") &&
    e.target === document.body
  ) {
    document.querySelector("mobile-search")?.close();
  }
});
